<template lang="pug">
  .s-cont
    .s-card
      .backgound-color(:style="`background: linear-gradient(45deg, ${hex}, ${brightness(hex, -40)});`" @click="handleClick()")
        .s-header
          h3.title {{ title }}
          span.badge.bold(:style="`color: ${hex}`") {{ count }}
        span.amount.bold(v-if="!notAmount") {{ amount | currency }}
        span.amount.bold(v-else) -
</template>

<script>
export default {
  name: 'stat-card',
  data: () => ({}),
  props: {
    title: {
      type: String,
      default: 'Title'
    },
    name: {
      type: String,
      default: 'test'
    },
    amount: {
      type: Number,
      default: 0
    },
    notAmount: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      default: 0
    },
    width: {
      type: String,
      default: '100%'
    },
    hex: {
      type: String,
      default: '#ED1B24'
    },
    focus: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    brightness (col, amt) {
      let usePound = false
      if (col[0] === '#') {
        col = col.slice(1)
        usePound = true
      }
      let num = parseInt(col, 16)
      let r = (num >> 16) + amt
      if (r > 255) r = 255; else if (r < 0) r = 0
      let b = ((num >> 8) & 0x00FF) + amt
      if (b > 255) b = 255; else if (b < 0) b = 0
      let g = (num & 0x0000FF) + amt
      if (g > 255) g = 255; else if (g < 0) g = 0
      return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16)
    },
    handleClick () {
      this.$router.push(`/${this.name}`)
      this.$emit('click', this.name)
    }
  }
}
</script>

<style lang="scss" scoped>
.s-cont {
  min-width: 230px;
  height: 100px;
  padding: 5px;
  border-radius: 10px;
  box-sizing: content-box;
  margin: 0 1px;
  position: relative;
  user-select: none;
  border: 4px solid transparent;
  cursor: pointer;
  transition: 0.2s transform ease-in-out;
}
.s-cont:hover {
  transform: scale(1.05);
  border: 3px solid #3499DB;
}
.activeCard {
  border: 0px solid #3499DB;
}
.s-card {
  height: 100%;
  border-radius: 10px;
}
.s-header {
  display: flex;
  align-items: center;
}
.title {
  z-index: 1;
  font-weight: light;
  line-height: 1rem;
}
.badge {
  background: white;
  border-radius: 20px;
  padding: 0 15px;
  margin-left: 10px;
}
.amount {
  font-size: 1.8rem;
}
.bold {
  font-weight: bold;
}
.backgound-color {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  padding: 18px 15px;
  color: white;
}
.fix-height {
  height: 24px;
}
button {
  border: 0 !important;
  height: 24px !important;
  padding: 0 !important;
}
.view-btn {
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.1s all ease-in-out;
  margin: 0 0 0 auto;
}
.view-btn:hover {
  border-radius: 5px;
  background: rgba($color: #000000, $alpha: 0.2)
}
</style>
